import { call, put, select, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '../../api/api';
import { cardsActions, AddTagPayload } from '../cards.slice';
import { RootState } from '../../store/rootReducer';
import { markupFormatter } from '../../common';

function* addTagWorker(action: PayloadAction<AddTagPayload>) {
    const { cardId, tag } = action.payload;
    const markup: string = (yield select((s: RootState) => s.cards[cardId]?.markup ?? '')) as string;
    const tree = markupFormatter.parse(markup);
    if (tree.tags.includes(tag))
        return;
    tree.tags = [...tree.tags, tag];
    const newMarkup = markupFormatter.format(tree);
    yield call([api, api.setMarkup], { cardId, markup: newMarkup });
    yield put(cardsActions.setMarkup({ cardId, markup: newMarkup }));
}

export function* addTagSaga() {
    yield takeEvery(cardsActions.addTag.type, addTagWorker);
}
